import dayjs from 'dayjs';
import FetchJson from '$util/fetchJson';

export default (apiKey, consumerApiUrl, setState) =>
  class Api {
    constructor() {
      const commonHeaders = () => ({
        'x-api-key': apiKey,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      });

      this.vehicleApi = () =>
        new FetchJson({ baseURL: `${consumerApiUrl}/vehicles/lookup/`, headers: commonHeaders(apiKey) });

      this.customerApi = () =>
        new FetchJson({ baseURL: `${consumerApiUrl}/customers/`, headers: commonHeaders(apiKey) });

      this.customerVehicleApi = (authKey) =>
        new FetchJson({
          baseURL: `${(consumerApiUrl, consumerApiUrl)}/customers/`,
          headers: Object.assign(commonHeaders(apiKey), { Authorization: authKey }),
        });

      this.checkVrm = async (vrm) => {
        const cleanedVrm = vrm.replace(/\s/g, '');
        const regex = /^[a-zA-Z0-9]*$/i;
        if (!cleanedVrm || cleanedVrm.length < 3 || !regex.test(cleanedVrm)) {
          return setState({ vrmError: true, vrmUnrecognised: false });
        }

        try {
          const { data: vehicle } = await this.vehicleApi().get(cleanedVrm);
          if (!vehicle.make) return setState({ vrmError: true, vrmUnrecognised: false });

          const expiryDate = dayjs(vehicle.motExpiryDate);
          return setState({
            vrmError: false,
            vrmIsValid: true,
            vehicleId: vehicle.vehicleId,
            motExpired: dayjs().isAfter(expiryDate),
            motDueDate: expiryDate.format('D/M/YYYY'),
          });
        } catch (error) {
          return setState({ vrmUnrecognised: true, vrmError: false });
        }
      };

      this.setReminder = async (email, vehicleId, source, type, monthsTillService) => {
        const regex =
          // eslint-disable-next-line max-len
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!email || !regex.test(String(email).toLowerCase())) {
          return setState({ emailError: true });
        }

        const handleLinkAndSetReminder = async (customer) => {
          // Set reminder
          // currently we are only creating a guest user from the blog widget so we can hardcode it to "GUEST"
          const reminderData = {
            customerEmail: email,
            customerStatus: 'GUEST',
            status: 'active',
            // customer-vehicle status (we need to pass something or it returns an empty update error)
          };

          switch (type) {
            case 'service':
              reminderData.serviceReminderOptIn = true;
              reminderData.monthsTillService = monthsTillService;
              break;
            case 'subscribe':
              reminderData.marketingConsent = true;
              reminderData.emailSubscriber = true;
              break;
            default:
              reminderData.reminderEmail = true; // MOT reminder
              break;
          }

          await this.customerVehicleApi(customer.accessToken).patch(
            `${customer.id}/vehicles/${vehicleId}`,
            reminderData
          );

          return setState({ reminderSuccess: true });
        };

        /**
         * Create a guest customer
         * Update the guest customer with the email address provided
         * Associate this guest customer with the vehicle and set MOT/service reminder
         */
        try {
          const { data: customer } = await this.customerApi().post('', {
            partner: 'none',
            source,
          });
          return await handleLinkAndSetReminder(customer);
        } catch (error) {
          if (error) throw new Error(error);
        }
        return true;
      };
    }
  };
